import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { Suggestion } from './types';
import { StoreState } from '@mm/state/store-interfaces';
import modalActions from '@mm/state/modules/modalsState/actions';
import { NETWORK_ERROR_MODAL_TITLE } from '@mm/constants/error-descriptions';

export const useConfirmModalHandler = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  const openErrorModal = (err?: string) => {
    const modalProps = {
      detailsForNerds: err,
      errorMessage: 'Unfortunately this bot can not be copied',
      title: NETWORK_ERROR_MODAL_TITLE,
    };
    dispatch(modalActions.openPrettyErrorModal(modalProps));
  };

  const openConfirmModal = (
    suggestion: Suggestion,
    handler?: (startBotId: number, v: Suggestion) => void,
  ) => {
    const { id, name, pageId, destinationPageId } = suggestion;
    if (!id || !name) openErrorModal();

    const startBotPageId = pageId || destinationPageId || id;

    const onCloseHandler = (isSuccess: boolean) =>
      isSuccess &&
      handler &&
      startBotPageId &&
      handler(Number(startBotPageId), suggestion);

    const modalProps = {
      headerText: 'Copy an existing dialogue',
      messageText: `Copy Dialogue from ${name}?`,
      okButtonText: 'OK',
      okButtonStyling: { blue: true },
      cancelButtonText: 'Cancel',
      onCloseHandler,
    };

    dispatch(modalActions.openGeneralConfirmModal(modalProps));
  };

  return { openConfirmModal };
};
